// @ts-nocheck
import { DetailRequirement, FieldModel, TraitId } from '@cibo/core'
import { Skeleton, Stack, TextField, Typography } from '@mui/material'
import { Field as FormikField } from 'formik'
import { ChangeEvent, useState } from 'react'

import { propEq } from 'ramda'

type GenericDetailEditorProps = {
  fieldModels?: FieldModel[]
  name?: string
  traitId: TraitId
  year?: number
  requirement?: DetailRequirement
}

const fieldName = 'detailEditor'

export const detailFromGenericEditorValues = (values: any, requirement: DetailRequirement) => {
  return { ...values.detailEditor, traitId: requirement.traitId, year: requirement.year }
}

export const GenericDetailEditor = ({
  traitId,
  fieldModels,
  year,
  name = 'genericDetailEditor',
}: GenericDetailEditorProps) => {
  const fieldModel = !!fieldModels?.length && fieldModels[0]
  const details = fieldModel?.details?.filter(propEq('traitId', traitId))

  const [fieldString, setFieldString] = useState('')

  return (
    <FormikField name={fieldName} id={fieldName}>
      {({ field: { value }, form: { setFieldValue } }) => (
        <>
          <pre>{fieldModel?.resourceId}</pre>
          <pre>
            {traitId} {year}
          </pre>

          {!!details && !!details.length && (
            <div>
              <pre>existing value(s):</pre>
              {details.map((detail, index) => (
                <div key={index}>
                  <pre>{JSON.stringify(detail, null, 2)}</pre>
                </div>
              ))}
            </div>
          )}

          <TextField
            autoFocus
            margin="dense"
            id="value"
            label="enter the value"
            fullWidth
            multiline
            variant="standard"
            value={fieldString}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              try {
                const input = JSON.parse(event.target.value)
                setFieldValue(fieldName, input)
              } catch (e) {
                setFieldValue(fieldName, event.target.value)
              }
              setFieldString(event.target.value)
            }}
          />
        </>
      )}
    </FormikField>
  )
}

export const GenericEditorSkeleton = () => (
  <Stack spacing={1}>
    <Typography>
      <Skeleton width={300} />
    </Typography>
    <Typography variant="caption">
      <Skeleton width={420} />
    </Typography>
    <Skeleton variant="rectangle" width={'100%'} height={80} />
  </Stack>
)
